/**
 * Sysadmin route component that requires sysadmin privileges
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../shared/auth';

interface SysadminRouteProps {
  children: React.ReactNode;
}

export function SysadminRoute({ children }: SysadminRouteProps) {
  const { user } = useAuth();

  if (!user?.is_sysadmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
